<template>
  <div class="container py-5 text-center">
    <p class="font_orange" style="font-size: 18px;">결제에 실패했습니다.</p>
    <p v-if="message">{{ message }}</p>
    <button class="btn btn_md btn_deepbrown mt20" @click="$router.push('/mypage/PrescriptionList')">
      처방 내역으로 이동
    </button>
  </div>
</template>

<script>
export default {
  name: 'TossPaymentFail',
  computed: {
    message() {
      return this.$route.query.message || ''
    },
  },
}
</script>